
//  Link media
require.context('../media/', true, /^\.\/.*\.*/);
require.context('../fonts/', true, /^\.\/.*\.*/);


//  Styles
import '../styles/styles.scss';

// JS
import $ from 'jquery';

import utils from './proj/utils';
import Tracker from './proj/tracker';
import loadChartbeat from './proj/chartbeat';
import Waypoint from 'Waypoint';
// import zenscroll from 'zenscroll';
import triggerWaypoints from './proj/waypoints/triggers';
import handleLazySizes from './proj/handleLazySizes';
// import DropDown from './proj/Dropdown';
import InView from './proj/inview';
import Slick from './proj/slick';

let Site;
const isMobileDevice = utils.mobileAndTabletCheck();
const isMobile = window.innerWidth < 800 || isMobileDevice;


const playVideo = function(vid) {

	var playPromise = vid.play();

	if (playPromise !== undefined) {
		playPromise.then(function() {
			// Automatic playback started!
		}).catch(function(error) {
			vid.muted = true;
			vid.play();
			// Automatic playback failed.
			// Show a UI element to let the user manually start playback.
		});
	}
};

const pauseVideo = function(vid) {
	vid.pause();
};

const updateVideoSrc = function(vid) {
		const src = vid.getAttribute('data-vid-src');
		const newSrc = (isMobile) ? src.replace(".mp4", "-mob.mp4") : src;
		vid.setAttribute('data-src', newSrc);
};

(function ($) {
	'use strict';

	Site = {
		/**
		 * initialize prototype
		 *
		 */
		init: function (elt) {
			console.log('Site init');
			var self = this;

			// self.zenscroll();
			// self.waypointsChapter();
			self.navTitle();
			self.cnnTracker();
			// self.cnnPlayer();
			self.lazySizes();
			self.waypoints();
			// self.setupAutoplay();
			// self.handleVideoSrc();


			// project specific
			self.inviewAnimation();
			self.relatedCarousel();
			

			self.updateHero();

			self.initChartbeat();

			$('body').addClass('loaded');

			// $(window).on('resize', self.updateHero);
		},

		/**
		 * inview animation
		 *
		 */
		 inviewAnimation: function(){
			$("[class*='ivanim-']").on('inview', function(event, isInView) {
				if (isInView) {
					if (!$(this).hasClass('is-inview')) {
						$(this).addClass('is-inview');
					}
				}
			});
		},

		updateHero: function() {
			// if( isMobileDevice ) {
			// 	document.querySelector('.hero').style.height = window.innerHeight +'px';
			// }
			$('.hero__content').addClass('show');
		},

		/**
		 * related carousel footer
		 *
		 */
		relatedCarousel: function(){
			var speed_val = 1000;
			var speed_autoplay_val = 4000;

			setTimeout(function(){
				$('.js-related-links').slick({
					dots: true,
					infinite: true,
					speed: speed_val,
					slide: '.js-slide',
					centerMode: true,
					variableWidth: true,
					slidesToScroll: 1,
					autoplay: false,
					responsive: [
						{
							breakpoint: 480,
							settings: {
								centerMode: false,
								arrows: false
							}
						}
						// You can unslick at a given breakpoint now by adding:
						// settings: "unslick"
						// instead of a settings object
					]
				});

				setTimeout( function() {
					window.dispatchEvent( new Event('resize') );
				}, 2000);

			}, 2000);
		},


		handleVideoSrc: function() {

			const vids = document.querySelectorAll("video[data-vid-src]");
			const suffix = (isMobile) ? '-mob' : '';
			[...vids].forEach( updateVideoSrc );
		},

		setupAutoplay: function() {
			const waypointContext = window;
			const autoplayLoops = $('.js-video-play-in-view');
			let waypoints = [];
			$.each(autoplayLoops, function(idx, el) {


				const $el = $(el);
				const vidId = $el.attr('data-video-target');
				const vid = document.getElementById(vidId);


					// container enters viewport (scrolling down) or leaves viewport (scrolling back up)
					waypoints.push(
						new Waypoint({
						  element: el,
						  handler: function(direction) {
							if( direction === 'down' && vid ) {
									playVideo( vid );
							} else {
									pauseVideo(vid);
							}
						  },
						  context: waypointContext,
						  offset: '80%'
						})
					);

					// container exits (scrolling down) or enters (scrolling back up)
					waypoints.push(
						new Waypoint({
						  element: el,
						  handler: function(direction) {
							if( direction === 'down' && vid ) {
									pauseVideo(vid);
							} else {
									playVideo( vid );
							}
						  },
						  context: waypointContext,
						  offset: function() { return -this.element.clientHeight; }
						})
					);

			});
		},

		/**
		 * Nav title
		 *
		 */
		navTitle: function(){

			// $('.nav-title').addClass('is-visible');

			// update dropdown menu when scrolling to new chapters
			var waypoint = new Waypoint({
				element: document.getElementById('waypoint_hero'),
				handler: function(direction) {
					if(direction === 'up') {
						$('.nav-title').removeClass('is-visible');
					} 
					else {
						$('.nav-title').addClass('is-visible');
					}
				},
				offset: '-100%'
			});

			
			$('.scroll-indicator').on('click', function(){
				$('html,body').animate({ scrollTop: $(window).height() - 52 },'slow');
			});
		},


		/**
		 * CNN page view trackers
		 *
		 */
		cnnTracker: function(){
			// const tracker = new Tracker('cnnix-intl-sudan-uprising');
			// tracker.trackOnce( 'load' );
		},

		/**
		 * Image lazy sizes
		 *
		 */
		lazySizes: function(){
			handleLazySizes();
		},


		/**
		 * Image lazy sizes
		 *
		 */
		initChartbeat: function(){
			// relies on global set in head
			if( window.CNN && window.CNN.omniture && window.CNN.omniture.section ) {
				loadChartbeat( window.CNN.omniture.section[0], "CNN Interactives");
			}

		},


		/**
		 * CNN page view trackers
		 *
		 */
		cnnPlayer: function(){
			if( FAVEPlayer ) {
				FAVEPlayer.create($('.fave'));
			}
		},

		/**
		 * scrolling setup
		 *
		 */
		zenscroll: function(){
			// scrolling setup
			let scroller;
			if( isMobile ) {
				$('html').addClass('mobile');

				const defaultDuration = 500;
				const edgeOffset = 30;
				scroller =  zenscroll.createScroller( document.getElementById("app"), defaultDuration, edgeOffset);
			} else {
				scroller = zenscroll;
			}

			const dd = new DropDown( $('#dd'), scroller );
		},

		/**
		 * waypoints Chapter
		 *
		 */
		waypoints: function(){

			let waypoints = [];
			const waypointContext = window;

			// set up all the triggers from paragraphs
			const displayTriggers = $('.js-wp-trigger');
			// console.log('................. triggers');
			// console.log(displayTriggers);
			const displayTriggerWaypoints = triggerWaypoints( waypoints, waypointContext );
			$.each( displayTriggers, displayTriggerWaypoints );

		}
	};


	$(document).ready( function(){
		Site.init();
	})

})(jQuery);



// WEBPACK FOOTER //
// ./src/js/main.js